import styled from "styled-components"

const Title = styled.h2`
  &::after {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`

const GalerieTitle = styled.h3`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`

const GalerieItemContainer = styled.div``

const ListGalerieHeader = styled.div``

export { Title, GalerieTitle, GalerieItemContainer, ListGalerieHeader }
